export const CaseStatus = {
  New: -2,
  Created: -1,
  Registered: 0,
  Processed: 1,
  Approved: 2,
  WorkDone: 3,
  Closed: 4,
  RequiresAdditionalInformation: 5,
  Declined: 6,
  Revoked: 7
};

export const CaseStatusGroup = {
  Ongoing: 0,
  Completed: 1
};
